module.exports = __webpack_public_path__ + "static/media/pluck.370bdd2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/pluck.mp3
// module id = MbY0
// module chunks = 74